<div class="fullcontainer">
  @if (this.isError) {
    <div class="alert alert-danger">Please complete all required fields</div>
  }
  @if (this.isServerError) {
    <div class="alert alert-danger">Something went wrong. Please try again later.</div>
  }
  @if (this.isSuccess) {
    <div class="alert alert-success">Driver was updated successfully</div>
  }
  <div class='sheet'>
    <h1 class='header'>Edit Driver - {{ this.driver.firstName }} {{ this.driver.lastName }}</h1>
    <app-audit-line [data]='this.driver'></app-audit-line>
    <form (ngSubmit)='this.onSubmit()' method='post'>
      <app-driver-form [driver]='this.driver'></app-driver-form>
      <button type="submit" class="btn btn-success">Save</button>&nbsp;
      <button type="button" class="btn btn-danger" routerLink='/drivers'>Cancel</button>
    </form>
  </div>
</div>
